/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type Share_event$ref = any;
export type DownPaymentDistribution = "FIXED" | "PERCENT" | "%future added value";
export type PaymentStatus = "INITIAL" | "PAID" | "%future added value";
export type PplanDistributionEnum = "EQUAL" | "FIXED" | "PERCENT" | "%future added value";
export type PplanStatusEnum = "INITIAL" | "PAID" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceContainer_node$ref: FragmentReference;
export type InvoiceContainer_node = {|
  +id: string,
  +title: ?string,
  +can_edit: ?boolean,
  +can_email: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +recipient_first_name: ?string,
  +recipient_last_name: ?string,
  +recipient_company_name: ?string,
  +recipient_email: ?string,
  +recipient_phone: ?string,
  +recipient_address: ?string,
  +deletable: ?boolean,
  +down_payment_cents: ?number,
  +down_payment_currency: ?string,
  +down_payment_distribution_type: ?DownPaymentDistribution,
  +down_payment_due_at: ?any,
  +down_payment_percent: ?number,
  +down_payment_status: ?PaymentStatus,
  +number: ?string,
  +pplan_distribution_type: ?PplanDistributionEnum,
  +total_cents: ?number,
  +total_paid_cents: ?number,
  +accepted_payment_methods: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?({|
        +__typename: "CashPaymentMethod",
        +id: string,
        +enabled: ?boolean,
        +instructions: ?string,
      |} | {|
        +__typename: "CheckPaymentMethod",
        +address: ?string,
        +pay_to: ?string,
      |} | {|
        +__typename: "CustomPaymentMethod",
        +label: ?string,
      |} | {|
        +__typename: "SquarePaymentMethod",
        +application_id: ?string,
        +location_id: ?string,
        +location_name: ?string,
      |} | {|
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        +__typename: "%other"
      |})
    |}>
  |},
  +i_pplan_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +amount_cents: ?number,
        +amount_currency: ?string,
        +due_at: ?any,
        +id: string,
        +locked: ?boolean,
        +status: ?PplanStatusEnum,
      |}
    |}>
  |},
  +invoice_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +invoice_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: "CashPayment",
        +id?: string,
        +amount_cents?: ?number,
        +amount_currency?: ?string,
        +name?: ?string,
        +notes?: ?string,
        +status?: ?PaymentStatus,
        +paid_at?: ?any,
        +refunds?: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +amount_cents: ?number,
              +amount_currency: ?string,
              +notes: ?string,
              +refunded_at: ?any,
            |}
          |}>
        |},
        +label?: ?string,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +$fragmentRefs: Share_event$ref,
        |},
      |}
    |}>
  |},
  +$refType: InvoiceContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "instructions",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_cents",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_currency",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "paid_at",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "refunds",
  "storageKey": null,
  "args": null,
  "concreteType": "RefundConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "RefundEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Refund",
          "plural": false,
          "selections": [
            v0,
            v6,
            v7,
            v9,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "refunded_at",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v15 = [
  v2,
  v0,
  v6,
  v7,
  v12,
  v9,
  v8,
  v13,
  v14
];
return {
  "kind": "Fragment",
  "name": "InvoiceContainer_node",
  "type": "Invoice",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "invoice_event_segments"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "invoice_line_items"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_currency",
      "args": null,
      "storageKey": null
    },
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "share_token",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_first_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_last_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_company_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_phone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "recipient_address",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "deletable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_cents",
      "args": null,
      "storageKey": null
    },
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_distribution_type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_due_at",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_percent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "down_payment_status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "number",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pplan_distribution_type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "total_cents",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "total_paid_cents",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "accepted_payment_methods",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentMethodConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PaymentMethodEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [
                v2,
                {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [
                    v0,
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "application_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location_name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [
                    v0,
                    v3,
                    v4,
                    v5
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "address",
                      "args": null,
                      "storageKey": null
                    },
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "pay_to",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [
                    v0,
                    v3,
                    v5
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "i_pplan_items",
      "storageKey": null,
      "args": null,
      "concreteType": "IPplanItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "IPplanItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "IPplanItem",
              "plural": false,
              "selections": [
                v6,
                v7,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "due_at",
                  "args": null,
                  "storageKey": null
                },
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "locked",
                  "args": null,
                  "storageKey": null
                },
                v8
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "invoice_event_segments",
      "name": "__InvoiceContainer_invoice_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceEventSegmentConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "InvoiceEventSegmentEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceEventSegment",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                },
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                },
                v9,
                v2
              ]
            },
            v10
          ]
        },
        v11
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "invoice_line_items",
      "name": "__InvoiceContainer_invoice_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "InvoiceLineItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "InvoiceLineItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "InvoiceLineItem",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                },
                v1,
                v2
              ]
            },
            v10
          ]
        },
        v11
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "payments",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PaymentEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "SquarePayment",
                  "selections": [
                    v2,
                    v0,
                    v6,
                    v7,
                    v12,
                    v13,
                    v14
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CustomPayment",
                  "selections": [
                    v2,
                    v0,
                    v6,
                    v7,
                    v12,
                    v9,
                    v8,
                    v4,
                    v13,
                    v14
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CheckPayment",
                  "selections": v15
                },
                {
                  "kind": "InlineFragment",
                  "type": "CashPayment",
                  "selections": v15
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkspaceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Workspace",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [
                    v0,
                    {
                      "kind": "FragmentSpread",
                      "name": "Share_event",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f91ebe1f5905a198ffa445bd44d4e955';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/__generated__/InvoiceContainer_node.graphql.js